module.exports = __webpack_public_path__ + "img/bg_duoduop_des_4.2536c240.jpg";